import { Fragment } from 'react'
import { m } from '~/paraglide/messages'
import imgCalculatorAppIcon from '../assets/images/calc.png'
import { AppleNotesIcon } from './icons/apple-notes'
import { CanvaIcon } from './icons/canva'
import { CapCutIcon } from './icons/cap-cut'
import { GoogleCalendarIcon } from './icons/google-calendar'
import { NotionIcon } from './icons/notion'
import { PinterestIcon } from './icons/pintrest'
import { SlackIcon } from './icons/slack'
import { SpotifyIcon } from './icons/spotify'
import { MicrosoftTeamsIcon } from './icons/teams'

type OptionConfig = {
  name: () => string
  icons: ({ component: typeof SpotifyIcon; className?: string } | string)[]
}

const options: OptionConfig[] = [
  {
    name: m.daily_paywall_allow_list_name_study,
    icons: [
      { component: MicrosoftTeamsIcon, className: 'w-[26.8px]' },
      { component: NotionIcon, className: 'w-[26px]' },
      imgCalculatorAppIcon,
      { component: SpotifyIcon, className: 'w-[25.5px]' },
    ],
  },
  {
    name: m.daily_paywall_allow_list_name_create,
    icons: [
      { component: PinterestIcon, className: 'w-[27px]' },
      { component: CapCutIcon, className: 'w-[27.8px]' },
      { component: CanvaIcon, className: 'w-7' },
      { component: AppleNotesIcon, className: 'w-[27px]' },
    ],
  },
  {
    name: m.daily_paywall_allow_list_name_work,
    icons: [
      { component: SlackIcon, className: 'w-[25.5px]' },
      { component: NotionIcon, className: 'w-[26px]' },
      { component: GoogleCalendarIcon, className: 'w-[26.3px]' },
      { component: SpotifyIcon, className: 'w-[25.5px]' },
    ],
  },
]

export function OptionList() {
  return (
    <div className="flex w-full shrink-0 flex-col items-end gap-2">
      {options.map((option, optionIndex) => {
        const isLastOption = optionIndex === options.length - 1

        return (
          <Fragment key={option.name()}>
            <div className="flex w-full shrink-0 items-center justify-between">
              {/* Label */}
              <div className="flex shrink-0 items-center gap-2">
                <div>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="10" cy="10" r="10" fill="#72DEDE" />
                    <circle cx="10" cy="10.0002" r="6.66667" fill="#07A1A1" />
                  </svg>
                </div>
                <p className="font-semibold text-[#333333]">{option.name()}</p>
              </div>

              {/* Icons */}
              <div className="flex shrink-0 items-center gap-1">
                {option.icons.map((icon, iconIndex) => (
                  <div
                    key={iconIndex}
                    className="grid size-8 shrink-0 place-items-center"
                  >
                    {typeof icon === 'string' ? (
                      <img alt="" className="size-full" src={icon} />
                    ) : (
                      <icon.component className={icon.className} />
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Divider */}
            {!isLastOption && <div className="h-[0.365px] w-full shrink-0" />}
          </Fragment>
        )
      })}
    </div>
  )
}
